var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.48099 0.654445L0.172037 4.4367C-0.218469 4.8824 0.0989037 5.58062 0.691562 5.58062L7.30947 5.58062C7.44211 5.58073 7.57196 5.54261 7.68349 5.47082C7.79502 5.39903 7.88349 5.29661 7.93831 5.17583C7.99313 5.05506 8.01198 4.92104 7.99259 4.78982C7.9732 4.65861 7.9164 4.53577 7.82899 4.43601L4.52004 0.655135C4.45528 0.581029 4.37542 0.521634 4.28581 0.480939C4.19621 0.440244 4.09893 0.419189 4.00051 0.41919C3.9021 0.41919 3.80482 0.440244 3.71522 0.480939C3.62561 0.521634 3.54575 0.580339 3.48099 0.654445Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTriangle);
export default __webpack_public_path__ + "static/media/grayTriangle.12ed86e1c2be2352e423778113bc810a.svg";
export { ForwardRef as ReactComponent };